import React, { useLayoutEffect, useState } from 'react';
import { differenceWith, isEqual } from 'lodash';

import { Interaction, TutoringSession } from '@test_prep/app/ai_tutor/types';

import InteractionCard from '../interaction';

interface Props {
  addOrUpdateUserInteractions: (interactions: Interaction[]) => void;
  submitUserInput: (text: string) => void;
  tutoringSession: TutoringSession;
}

const TutoringSessionInteractions: React.FC<Props> = (props) => {
  const [previousInteractions, setPreviousInteractions] = useState<Interaction[]>(props.tutoringSession.interactions);

  // Whenever there are new interactions scroll to make them visible
  useLayoutEffect(() => {
    const newInteractions = differenceWith(
      props.tutoringSession.interactions,
      previousInteractions,
      isEqual
    );

    setPreviousInteractions(props.tutoringSession.interactions);

    const newInteraction = document.getElementById(newInteractions[0]?.id);
    newInteraction?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [props.tutoringSession.interactions]);

  return (
    <div className="d-flex flex-1 flex-column gap-m">
      {
        props.tutoringSession.interactions.map((interaction) => (
          <div key={interaction.id} id={interaction.id.toString()}>
            <InteractionCard
              interaction={interaction}
              onOptionSelected={props.submitUserInput}
              addOrUpdateUserInteractions={props.addOrUpdateUserInteractions}
              tutoringSessionId={props.tutoringSession.id}
            />
          </div>
        ))
      }
    </div>
  );
};

export default TutoringSessionInteractions;
